module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_LCSAthFull_v3.5931fb3c.jpg";